import { fetchLoginCall } from "../ajax";
import { API_CONSTANTS, API_METHODS } from "../api-constant";

export const SaveAppVersion = async (payload) => {
  const url = `${API_CONSTANTS.SAVE_APP_VERSION}`;
  return fetchLoginCall(url, API_METHODS.POST, payload);
};

export const GetAllAppVersions = async (payload) => {
  const url = `${API_CONSTANTS.GET_ALL_APP_VERSIONS}`;
  return fetchLoginCall(url, API_METHODS.POST, payload);
};

export const GetAppVersion = async (platform) => {
  const url = `${API_CONSTANTS.GET_APP_VERSION}?platform=${platform}`;
  return fetchLoginCall(url, API_METHODS.GET);
};
